import { createTheme } from '@material-ui/core';
import typography from './fonts';
import colorPalette from './color-palette';

import muiOverrides from './overrides';

import knockoutSumoFile from '../fonts/zizzi/Knockout-54Sumo.otf';
import knockoutFullSumoFile from '../fonts/zizzi/Knockout-74FullSumo.otf';
import knockoutJuniorMiddleweightFile from '../fonts/zizzi/Knockout-31JuniorMiddlewt.otf';
import knockoutMiddleweightFile from '../fonts/zizzi/Knockout-51Middleweight.otf';

const knockoutSumo = {
  fontFamily: 'Knockout-Sumo',
  fontStyle: 'normal',
  fontDisplay: 'swap' as const,
  fontWeight: 400,
  src: `url(${knockoutSumoFile})`,
};

const knockoutFullSumo = {
  fontFamily: 'Knockout-Full-Sumo',
  fontStyle: 'normal',
  fontDisplay: 'swap' as const,
  fontWeight: 400,
  src: `url(${knockoutFullSumoFile})`,
};

const knockoutJuniorMiddleweight = {
  fontFamily: 'Knockout-Junior-Middleweight',
  fontStyle: 'normal',
  fontDisplay: 'swap' as const,
  fontWeight: 400,
  src: `url(${knockoutJuniorMiddleweightFile})`,
};

const knockoutMiddleweight = {
  fontFamily: 'Knockout-Middleweight',
  fontStyle: 'normal',
  fontDisplay: 'swap' as const,
  fontWeight: 400,
  src: `url(${knockoutMiddleweightFile})`,
};

const theme = createTheme({
  name: 'zizzi',
  spacing: 4,
  palette: { ...colorPalette },
  typography: {
    h1: {
      fontFamily: typography.secondary,
      fontSize: '2rem',
      letterSpacing: 0,
    },
    h2: {
      fontFamily: typography.secondary,
      fontSize: '1.5rem',
      letterSpacing: 0,
    },
    h3: {
      fontFamily: typography.primary,
      fontSize: '1.25rem',
      fontWeight: 'bold' as const,
      letterSpacing: 0,
    },
    h4: {
      fontFamily: typography.primary,
      fontSize: '0.875rem',
      fontWeight: 'bold' as const,
      letterSpacing: 0,
    },
    h5: {
      fontFamily: typography.tertiary,
      fontSize: '1rem',
      letterSpacing: 0,
    },
    subtitle1: {
      fontFamily: typography.primary,
      fontSize: '0.85rem',
      fontWeight: 500,
    },
    subtitle2: {
      fontFamily: typography.primary,
      fontSize: '1rem',
      fontWeight: 300,
      paddingBottom: '2px',
    },
    body1: {
      fontFamily: typography.primary,
      fontSize: '0.875rem',
      fontWeight: 400,
      lineHeight: 1.1,
    },
    body2: {
      fontFamily: typography.primary,
      fontSize: '0.875rem',
      fontWeight: 'bold' as const,
      lineHeight: 1.3,
    },
    button: {
      fontFamily: typography.primary,
      fontSize: '0.875rem',
      fontWeight: 'bold' as const,
      textTransform: 'none',
      lineHeight: 1.3,
    },
    overline: {
      fontFamily: typography.primary,
      fontSize: '0.625rem',
      lineHeight: 1.3,
      fontWeight: 200,
      letterSpacing: '0.025rem',
      textTransform: 'none',
    },
  },
  overrides: {
    MuiCssBaseline: {
      '@global': {
        '@font-face': [
          knockoutSumo,
          knockoutFullSumo,
          knockoutJuniorMiddleweight,
          knockoutMiddleweight,
        ],
      },
    },
    ...muiOverrides,
  },
  splashImage: '/images/zizzi-splash.jpg',
});

export default theme;
